import { render, staticRenderFns } from "./UsersCampaign.vue?vue&type=template&id=4d5363df"
import script from "./UsersCampaign.vue?vue&type=script&lang=js"
export * from "./UsersCampaign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports